import { registerBlockType } from "@wordpress/blocks";
import {
  useBlockProps,
  __experimentalBlockVariationPicker as BlockVariationPicker,
} from "@wordpress/block-editor";
import apiFetch from "@wordpress/api-fetch";

import PluginBody from "./PluginBody";

import { page, pages, calendar } from "@wordpress/icons";

const variations = [
  {
    name: "iMakeable_single_calendar",
    isDefault: true,
    title: "CAL - single",
    description: "Kalendarz pojedyńczego pracownika",
    icon: page,
    attributes: { providerNameSlug: "iMakeable-calendar-single" },
  },
  {
    name: "iMakeable_main_calendar",
    title: "CAL - multiple",
    description: "Kalendarz ze wszystkimi pracownikami",
    icon: pages,
    attributes: { providerNameSlug: "iMakeable-calendar-multiple" },
  },
];

registerBlockType("create-block/imakeable-cal", {
  attributes: {
    userID: String,
    organizationID: String,
    variation: {
      type: "string",
      default: "",
    },
  },
	icon: calendar,
  save: ({ attributes }) => {
    return (
      <p {...useBlockProps.save()}>
        <PluginBody attr={attributes} />
      </p>
    );
  },
  edit: ({ attributes, setAttributes }) => {
    apiFetch({
      path: "/imakeable-cal-plugin/v1/userID",
      method: "POST",
    }).then(({ userID, organizationID }) => {
      setAttributes({ userID, organizationID });
    });

    if (!attributes.variation) {
      return (
        <div {...useBlockProps()}>
          <BlockVariationPicker
            variations={variations}
            label="Calendar Variant"
            onSelect={(variation = variations[0]) => {
              setAttributes({
                ...variation.attributes,
                variation: variation.name,
              });
            }}
          />
        </div>
      );
    }

    return (
      <p {...useBlockProps()}>
        <PluginBody attr={attributes} />
      </p>
    );
  },
});
